(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.service('ViewsService', [
        '$rootScope', 
        '$http', 
        '$localStorage',
        'ViewsBroadcast',
        ViewServiceFn
    ]);
    
    function ViewServiceFn(
        $rootScope, 
        $http,
        $localStorage,        
        ViewsBroadcast) {

        var baseUrl = '/api/views/';

        var views = [];
        var currentOwnerId;

        function get(url) {
            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        });
        }

        this.getViews = function() {
            return views; 
        };

        this.getCurrentView = function() {                        
            var isOperator = $rootScope.isRingfoon;
            var storedCurrentView = $localStorage.currentView;
            
            if (storedCurrentView && 
                storedCurrentView.ownerId === currentOwnerId) {
                return storedCurrentView;
            }
            let currentView = this.getDefaultView(isOperator);

            $localStorage.currentView = currentView;
            return currentView;
        };

        this.getViewForUser = function(userId) {
            return views.filter(view => view.viewUsers.find(viewUser => viewUser.userId === userId) !== undefined)[0];
        };

        this.getDefaultView = function(isOperator){
            // take the default view
            var currentView = views.filter(view => view.default &&
                view.forOperators === isOperator)[0];

            // operator & no default operator view? take the first operator view                                                    
            if (!currentView && isOperator) {
                currentView = views.filter(view => view.forOperators)[0];
            }

            // operator & no operator views? take the default non-operator view
            if (!currentView && isOperator) {
                currentView = views.filter(view => view.default)[0];
            }

            // no view? take the first view
            if (!currentView && views.length > 0) {
                currentView = views[0];
            }
            return currentView;
        }
        
        this.setCurrentView = function(view) {
            $localStorage.currentView = view;

            // notify that the view has changed
            $rootScope.$broadcast(ViewsBroadcast.ViewSelected, view);
        };

        this.getViewsForOwner = function(ownerId) {
            currentOwnerId = ownerId;
            var currentViewId = null;
            if ($localStorage.currentView) {
                currentViewId = $localStorage.currentView.id;
            }
            const promise = get(`${baseUrl}users/${ownerId}`);

            promise.then(function(ownerViews) {
                views = ownerViews;     
                
                // restore current view
                if (currentViewId) {
                    $localStorage.currentView = ownerViews.filter(v => v.id === currentViewId)[0];                    
                }

                $rootScope.$broadcast(ViewsBroadcast.ViewsRefreshed);
            });

            return promise;
        };      

        this.getView = function(id) {
            return get(`${baseUrl}${id}`);
        };

        this.createView = function(view) {
            return $http.post(`${baseUrl}`, view)
                        .then(function (response) {
                return response.data;
            });
        };

        this.updateView = function(view) {
            return $http.put(`${baseUrl}`, view)
                        .then(function (response) {
                return response.data;
            });
        };

        this.deleteView = function(viewId) {
            return $http.delete(`${baseUrl}${viewId}`)
                        .then(function (response) {
                return response.data;
            });
        };     
    } 

})();